import React from 'react'
import { Route, withRouter } from 'react-router-dom'
import './App.css'

import Home from './components/home'
import Search from './components/search'
import Viwer from './components/viewer'

import LogoHome from 'react-ionicons/lib/MdHome'
import LogoSearch from 'react-ionicons/lib/MdSearch'
// import LogoPricetag from 'react-ionicons/lib/MdPricetag'
// import LogoPricetag from 'react-ionicons/lib/MdPricetag'


class App extends React.Component {
  handleToHome = () => {
    this.props.history.push('/')
  }
  handleToSearch = () => {
    this.props.history.push('/search')
  }

  render() {
    return (
      <div>
        <div id='nav-bar'>
          <div className='header-button' onClick={this.handleToHome}><LogoHome fontSize='30px' /></div>
          <div className='header-button' onClick={this.handleToSearch}><LogoSearch fontSize='30px' /></div>
          {/* <div className='header-button' onClick={this.handleToSearch}><LogoPricetag fontSize='30px'/></div> */}
        </div>
        <Route exact path='/' component={Home} />
        <Route path='/article/*' component={Viwer} />
        <Route path='/search' component={Search} />
      </div>
    )
  }
}

export default withRouter(App)